import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/Nav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/components/svgs/tas-gov-logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/components/svgs/ubo-logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Work_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-work\"}],\"variableName\":\"work\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/styles/globals.css");
